import React from "react";
import { useSelector } from "react-redux";
import { CustomAutocomplete } from "./AutoComplete";
import {
  TextField,
} from "@mui/material";
export const RawItemsAutoComplete = ({ value, onChange,}) => {
  const rawItems = useSelector((state) => state.rawItems.rawItems);

  return (
    <CustomAutocomplete
      options={rawItems}
      getOptionLabel={(option) => option.name || ""}
      value={value}
      onChange={onChange}
      renderInput={(params) => <TextField {...params} label="Select Items" />}
    />
  );
};
